import { isFeatureVisible } from './isFeatureVisible';
export const getVisibleNamespaces = (namespaces, productId, paymentCycle) => (namespaces ?? []).filter(namespace => {
  var _namespace$metadata;
  return ((_namespace$metadata = namespace.metadata) == null ? void 0 : _namespace$metadata.displayInDesktop) !== 'false';
}).map(namespace => ({
  ...namespace,
  features: (namespace.features ?? []).filter(feature => isFeatureVisible(feature, productId, paymentCycle))
})).filter(namespace => namespace.features.length > 0);
//# sourceMappingURL=getVisibleNamespaces.js.map